import { render } from "./ModalRigaPagamento.vue?vue&type=template&id=93c1cd22&ts=true"
import script from "./ModalRigaPagamento.vue?vue&type=script&lang=ts"
export * from "./ModalRigaPagamento.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__